module.exports = __webpack_public_path__ + "img/blogger.005694a8.svg";